import {Action} from 'platform/components';

import i18n from '@dms/i18n';
import {Main, Section} from '@dms/shared';

import {buildArray, useRequiredParams} from 'shared/web';

import {TestDrivesCalendar} from './components/TestDrivesCalendar';
import {useCreateTestDriveAction} from './hooks/useCreateTestDriveAction';
import {TestDrives} from './TestDrives';

export function TestDrivesV2() {
  const {id: vehicleId} = useRequiredParams();
  const {canCreateTestDrive, openCreateTestDriveDialog} = useCreateTestDriveAction(vehicleId);

  return (
    <Main>
      <Section
        isFullHeight
        defaultActiveTab="list"
        actions={buildArray<Action>().when(canCreateTestDrive, {
          type: 'button',
          variant: 'primary',
          leftIcon: 'content/add_circle',
          title: i18n.t('entity.testDrive.labels.createTestDrive'),
          onClick: () => openCreateTestDriveDialog(),
        })}
        tabs={[
          {
            queryId: 'list',
            content: <TestDrives />,
            title: i18n.t('entity.testDrive.labels.list'),
          },
          {
            queryId: 'calendar',
            content: <TestDrivesCalendar />,
            title: i18n.t('entity.testDrive.labels.calendar'),
          },
        ]}
      />
    </Main>
  );
}
